<template>
  <gj-modal
      size="full-screen"
      :visible.sync="modalVisible"
      :contentStyle="{'height': '100%'}"
      :footer="false">
    <template #header>
      ASIN分析
    </template>
    <template #content>
      <div style="height: 100%; display: flex; flex-direction: column;">
        <app-listing-info
            :item="item"
            :currency-symbol="currencySymbol"
            :market-id="marketId"
        ></app-listing-info>
        <el-tabs value="first"
                 @tab-click="tabClick">
          <el-tab-pane label="投放类型分析" name="first" lazy>
            <app-asin-target-analysis
                :market-id="marketId"
                :currency-symbol="currencySymbol"
                :query-date="queryDate"
                :item="item">
            </app-asin-target-analysis>
          </el-tab-pane>
          <el-tab-pane label="广告位分析" name="second" lazy>
            <app-asin-placement-analysis
                :market-id="marketId"
                :currency-symbol="currencySymbol"
                :query-date="queryDate"
                :item="item"></app-asin-placement-analysis>
          </el-tab-pane>
          <el-tab-pane label="关键词分析" name="third" lazy>
            <app-asin-keyword-analysis
                :market-id="marketId"
                :currency-symbol="currencySymbol"
                :query-date="queryDate"
                :item="item">
            </app-asin-keyword-analysis>
          </el-tab-pane>
          <el-tab-pane label="商品投放分析" name="fourth" lazy>
            <app-asin-product-target-analysis
                :market-id="marketId"
                :currency-symbol="currencySymbol"
                :query-date="queryDate"
                :item="item"></app-asin-product-target-analysis>
          </el-tab-pane>
        </el-tabs>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../../minxins";
  import {adFields} from "../../../common/fields";
  import AppListingInfo from "../components/listing-info";
  import AppAsinKeywordAnalysis from "../components/asin-keyword-analysis";
  import AppAsinProductTargetAnalysis from "../components/asin-product-target-analysis";
  import AppAsinPlacementAnalysis from "../components/asin-placement-analysis";
  import AppAsinTargetAnalysis from "../components/asin-target-analysis";
  import {tabResizeMixin} from "../../../common/mixin";

  export default {
    name: "app-ad-asin-analysis-modal",
    components: {
      AppAsinTargetAnalysis,
      AppAsinPlacementAnalysis, AppAsinProductTargetAnalysis, AppAsinKeywordAnalysis, AppListingInfo},
    mixins: [modalMixIn, tabResizeMixin],
    props: {
      marketId: {
        required: true,
      },
      currencySymbol: {
        required: true,
      },
      item: {
        required: true
      },
      queryDate: {
        required: true
      }
    },
    data() {
      return {
        columns: [
          {id: 'listingInfo', header: '商品信息', field: 'slot:listingInfo', minWidth: '360px', fixed: 'left'},
          {...adFields.campaignName, minWidth: '130px', help: null, fixed: null, copyable: true},
          {...adFields.groupName, help: null, fixed: null, copyable: true},
          adFields.servingStatus,
          // adFields.creationDate,
          adFields.impressions,
          adFields.clicks,
          adFields.ctr,
          adFields.cost,
          adFields.cpc,
          adFields.orders,
          adFields.sales,
          adFields.acos,
          adFields.cvr,
          adFields.cpa,
          // adFields.acoas,
          // adFields.asoas,
          adFields.roas
        ],
        keyword: {
          key: 0,
          value: null,
        },
        date: null
      }
    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-tabs{
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
    .el-tabs__content{
      flex: 1;
      overflow: auto;
    }
    .el-tab-pane{
      height: 100%;
    }
  }
  /deep/ .operate-group{
    margin: 12px 0;
    
  }
</style>
